import { SecureAction } from '../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class ChartSecureAction extends SecureAction {
  public static readonly TOGGLE_ACTIVE_SENSORS: SecureAction = new ChartSecureAction(
    'device:monitoring:chart_group:chart:sensors:filter|active',
  );

  private constructor(name: string) {
    super(name);
  }
}
